import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingState from './common/LoadingState';

type UserRole = 'admin' | 'manager' | 'builder' | 'owner' | 'tenant' | 'guest';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
  redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  allowedRoles,
  redirectTo = '/dashboard'
}) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingState layout="page" fullScreen message="Cargando..." />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Si hay roles permitidos, verificar que el usuario tenga uno de ellos
  if (allowedRoles && allowedRoles.length > 0) {
    if (!allowedRoles.includes(user.role)) {
      if (user.role === 'manager') {
        return <Navigate to="/manager/delegations" replace />;
      }
      if (user.role === 'builder') {
        return <Navigate to="/builder/powers" replace />;
      }
      if (user.role === 'admin') {
        return <Navigate to="/admin/assemblies" replace />;
      }
      if (user.role === 'owner') {
        return <Navigate to="/dashboard" replace />;
      }
      return <Navigate to={redirectTo} replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
